import React, { Component } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import Form from '../form/Form'
import { Container, Grid, Icon, Message } from 'semantic-ui-react'
import CNCDictFormItem from './CNCDictFormItem'
import Button from '../form/Button'
import { updateUnit } from './CNCDictSublemma'
import { setFieldValue } from '../form/FormikHelpers'
import { valueByFormikPath } from '../../common'

interface CNCDictFormHomonymsProps extends WithTranslation {
    http: AxiosInstance,
    units: any[],
    close: (homonyms: any[]) => void
}

interface CNCDictFormHomonymsState {
    loading: boolean,
    errorMsg: string
}

class CNCDictFormHomonyms extends Component<CNCDictFormHomonymsProps, CNCDictFormHomonymsState> {

    state = {
        loading: false,
        errorMsg: ''
    }

    /*async deactivateHomonyms(units, fullDelete=false) {
        const { http } = this.props
        this.setState({loading: true})
        let updated: any[] = []
        for (let u of units) {
            let newUnit = structuredClone(u)
            if (fullDelete)
                newUnit.active = false
            else
                newUnit.domain = {written: false, spoken: false}
            updated.push(newUnit)
        }
        const errors = await updateUnits(http, updated, units)
        if (errors.length) {
            this.setState({errorMsg: errors.join("\n"), loading: false})
        } else {
            this.setState({extHomonyms: updated.filter(u => u.active), loading: false})
        }
    }*/


    async updateHomonyms(http, values, initialValues, formik) {
        const { close } = this.props
        let errors = []
        let updated: any[] = []
        this.setState({loading: true})
        for (let ui in values) {
            const unit = values[ui]
            const initialUnit = initialValues[ui]
            const res = await updateUnit(http, unit, initialUnit, errors)
            if (res) updated.push(unit)
        }
        if (errors.length) {
            this.setState({errorMsg: errors.join("\n"), loading: false})
        } else {
            this.setState({loading: false})
            close(updated)
        }
    }

    render() {
        const { units, http, close, t } = this.props

        const setDomain = (formik, domain, value) => {
            let units = formik.values
            for (let i in units) {
                const u = units[i]
                setFieldValue(formik, `${i}.domain.${domain}`, value, true)
            }
        }

        const setActive = (formik, value) => {
            let units = formik.values
            for (let i in formik.values) {
                const u = units[i]
                setFieldValue(formik, `${i}.active`, value, true)
            }
        }

        return(
            <Form initialValues={units} className="editform"
                onSubmit={(values: object, formikApi) => this.updateHomonyms(http, values, units, formikApi)}>
                {(formik) => {
                    const curunits = formik.values
                    return (
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Message info header={t('External homonyms')}/>
                            </Grid.Column>
                        </Grid.Row>
                        {this.state.errorMsg ?
                            (
                                <Grid.Row>
                                <Grid.Column width={16}>
                                    <Message error icon='exclamation triangle' header={t('Error')} content={this.state.errorMsg}/>
                                </Grid.Column>
                                </Grid.Row>
                            ) : null
                        }
                        <Grid.Row className='mcondensed control'>
                        <Grid.Column width={4}>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            { curunits.filter(u =>u.active).length > 0 ?
                                <Button type="button" icon="delete" size="mini" color="red" className="checkbox-size"
                                    onClick={()=> setActive(formik, false)}/> 
                            : 
                                <Button type="button" icon="undo" size="mini" color="yellow" className="checkbox-size"
                                    onClick={()=> setActive(formik, true)}/>
                            }
                        </Grid.Column>
                        <Grid.Column width={3}>
                            { curunits.filter(u =>u.domain.written).length > 0 ?
                                <Button type="button" icon="delete" size="mini" color="orange" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, 'written', false)}/>
                            :
                                <Button type="button" icon="check" size="mini" color="blue" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, 'written', true)}/>
                            }
                        </Grid.Column>
                        <Grid.Column width={3}>
                            { curunits.filter(u =>u.domain.spoken).length > 0 ?
                                <Button type="button" icon="delete" size="mini" color="orange" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, 'spoken', false)}/>
                            :
                                <Button type="button" icon="check" size="mini" color="blue" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, 'spoken', true)}/>
                            }
                        </Grid.Column>
                        </Grid.Row>
                        {curunits.map((u, ui) => {
                            return(<CNCDictFormItem formik={formik} prefix={ui.toString()} unit={u} showForm={true} setNewTag={()=>{}}/>)
                        })}
                        <Grid.Row>
                            <Grid.Column width={4}>
                                <Button type="button" color="yellow" onClick={() => close(units)}>{t('Close')}</Button>
                            </Grid.Column>
                            <Grid.Column width={12} textAlign='right'>
                                <Button.Submit disabled={!(formik.dirty && formik.isValid)} icon><Icon name="save"/> {t('Save changes')}</Button.Submit>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    )}
                }
            </Form>
        )
    }
}

export default withTranslation()(CNCDictFormHomonyms)